import React from 'react'
import Table from 'components/Table'
import Card from 'components/Card'
import constants from 'constants'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const styles = Object.assign(
  {},
  require('./PartnerPlanStatusTable.scss'),
  { columns: require('../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanStatusTable extends React.Component {
    getStatusCounts = (data) => {
      const counts = {}
      data.forEach((item) => {
        counts[item.planStatus] = (counts[item.planStatus] || 0) + 1
      })
      return counts
    }

    renderData = () => {
      const { data } = this.props
      const counts = this.getStatusCounts(data)
      return (Object.keys(counts).length > 0) && (
        <div>
          <Card noPadding className={styles.base}>
            <Table className={styles.base}>
              <thead>
                <tr>
                  <th className={classnames(styles.columns.summary, headerStyles)}>Progress summary</th>
                  <th className={classnames(styles.columns.count, headerStyles)}>Count</th>
                </tr>
              </thead>
              <tbody>
                {
                constants.PLANSTATUS.ORDER.map((def) => {
                    const count = counts[def.label] || 0
                    if (count === 0) { return null } // ✅ Only show if count > 0

                    return (
                      <tr className={styles.base} key={def.value}>
                        <td className={styles.columns.summary}>
                          {def.label}
                        </td>
                        <td className={styles.columns.count}>{count}</td>
                      </tr>
                    )
                })
                }
              </tbody>
            </Table>
          </Card>
        </div>
      )
    }

    render() {
      return (this.renderData())
    }
}
PartnerPlanStatusTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    planStatus: PropTypes.string.isRequired,
  })).isRequired,
}

export default PartnerPlanStatusTable




// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/components/PartnerPlanStatusTable.js